import { CellProps, Checkbox, Table } from "rsuite";
import { typeCountryDto } from "../../../utils/typeDefs";

const { Cell } = Table;

export const CountryCheckboxCell = ({
  rowData,
  dataKey,
  onChangeEvent,
  ...props
}: CellProps<any> & { onChangeEvent: (rowData: typeCountryDto) => void }) => {
  const isChecked = rowData && dataKey && !!rowData[dataKey];

  return (
    <Cell align="center" {...props}>
      <Checkbox
        defaultChecked={isChecked}
        onChange={(value, checked) => {
          onChangeEvent({ ...rowData, [dataKey ?? ""]: checked });
        }}
      />
    </Cell>
  );
};
